import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GroupPayorMappingComponent } from './group-payor-mapping.component';

const routes: Routes = [
  {
    path: '',
    component: GroupPayorMappingComponent,
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GroupPayorMappingRoutingModule { }
